// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2yHUo","title":"AfterBackImages_title__2GPCQ","images":"AfterBackImages_images__2wX77"};